import React from 'react'

import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Stack from '@mui/material/Stack'
import Switch from '@mui/material/Switch'

import { Text } from '@mxenabled/mxui'
import ListItemAvatar from '@mui/material/ListItemAvatar'

interface ToggleButtonListItemProps {
  avatar?: React.ReactNode
  endIcon?: React.ReactNode
  isChecked: boolean
  isDisabled?: boolean
  isPrimaryTextBold?: boolean
  onClick: () => void
  onToggle: () => void
  primaryText: string
  secondaryText?: string
}

export const ToggleButtonListItem = ({
  avatar,
  endIcon,
  isChecked,
  isDisabled = false,
  isPrimaryTextBold = false,
  onClick,
  onToggle,
  primaryText,
  secondaryText,
}: ToggleButtonListItemProps) => (
  //TODO: implement common/components/ListItemRow.tsx
  <ListItem
    secondaryAction={<Switch checked={isChecked} onChange={onToggle} />}
    sx={{
      '& .MuiListItemSecondaryAction-root': { right: !endIcon ? 24 : 64 },
      '& .MuiListItemButton-root': { pr: 24 },
    }}
  >
    <ListItemButton onClick={!isDisabled ? () => onClick() : undefined}>
      {avatar && <ListItemAvatar>{avatar}</ListItemAvatar>}
      <ListItemText slotProps={{ primary: { fontWeight: 400 } }}>
        <Stack alignItems="center" direction="row" justifyContent="space-between">
          <Stack sx={{ width: '100%' }}>
            <Text
              bold={isPrimaryTextBold}
              color="text.primary"
              sx={{
                mr: 80,
              }}
              variant="body1"
            >
              {primaryText}
            </Text>
            <Text color="text.secondary" variant="caption">
              {secondaryText}
            </Text>
          </Stack>
        </Stack>
      </ListItemText>
      {!isDisabled && endIcon && <ListItemIcon>{endIcon}</ListItemIcon>}
    </ListItemButton>
  </ListItem>
)
